import {useEffect} from "react";

import Steps from '../components/common/Steps';
import iconSuccess from '../assets/images/icon-success.png';
import {useHistory} from 'react-router-dom';
import {YUULINK, ONEPALINK} from '../libs/messages';

const Step2 = () => {
    const history = useHistory();
    const {location} = history
    useEffect(() => {
        if (!location || location.state?.from !== 'STEP1') {
            history.push('/error');
        }
    }, [history]);

    return (
        <div className={`app-step step-3`}>
            <div className="row justify-content-center">
                <div className="col-auto">
                    <div className="image-icon" style={{width: '100px', margin: '20px'}}>
                        <img src={iconSuccess} alt={''}/>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-10 col-md-12 sm-nopad">
                    <h2 className="title-message">
                        Thank you for making a difference to the community!
                        <br/>
                    </h2>
                    <div style={{textAlign: `center`, marginTop: `20px`}}>
                        Link your PAssion Membership in the yuu App to receive your yuu Points*. For more information on the yuu Rewards Club, click <a
                        href={YUULINK} rel="noreferrer"
                        target='_blank'> here</a>. 
                    </div>
                    <div style={{textAlign: `center`, marginTop: `20px`, fontSize: `12px`}}>
                     *Limited to the 1st event participated per day.
                     </div>
                    
                    
                    <div style={{textAlign: `center`, marginTop: `20px`, display:`none`}}>
                        To receive update on the crediting of your yuu points, link your PAssion Membership in the yuu
                        App. To download yuu App and for more information on the yuu Rewards Club, click <a
                        href={YUULINK} rel="noreferrer"
                        target='_blank'> here</a>
                    </div>
                    <div style={{fontSize: `12px`, textAlign: `center`, marginTop: `20px` ,display:`none`}}>
                        *Terms and Conditions apply.
                    </div>

                    {/* <div style={{textAlign: `center`, marginTop: `20px`}}>
					Link your PAssion Membership to your yuu Account for crediting of yuu Points. To download yuu App and for more information on the yuu Rewards Club. click <a href={ONEPALINK} target="_self">here</a>.
					</div> */}
                </div>
            </div>
        </div>
    );
};

export default Step2;
